import React from 'react';

import { useDispatch, useSelector } from '../store/hooks';
import { getCurrentColumns } from '../store/selectors/session';
import { getCurrentTab, getDefaultColumns } from '../store/selectors/ui';
import { hideOverlayFilters } from '../store/actions/ui';
import { setLeaseColumns, setSaleColumns } from '../store/actions/session';

import ColumnSelector from 'components/table_header/column_selector';
import { getCurrentColumnProps } from './helpers';

export default function CompsColumnSelector() {
  const edgeCrm = useSelector(state => state.features.edgeCrm);
  const currentColumns = useSelector(getCurrentColumns);
  const currentTab: string = useSelector(getCurrentTab);
  const customFieldSchemas = useSelector(state => state.customFieldSchemas);
  const currentColumnProps = getCurrentColumnProps(currentColumns, edgeCrm, customFieldSchemas, currentTab);
  const dispatch = useDispatch();

  return (
    <ColumnSelector
      {...currentColumnProps}
      defaultColumns={useSelector(getDefaultColumns)}
      onCancelColumns={() => dispatch(hideOverlayFilters())}
      onSetColumns={(columns) => {
        dispatch(currentTab === 'sale' ? setSaleColumns(columns) : setLeaseColumns(columns));
        dispatch(hideOverlayFilters());
      }}
    />
  );
}
